const initialState = {
  selectedFields: [],
  generatedSql: '',
  isLoading: false,
  isExecuting: false,
  queryResults: null,
  error: null,
  successMessage: null,
  savedQueries: [],
  currentQueryId: null,
  hasUnsavedChanges: false
};

export default initialState;
